"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
require("./styles/contact.scss");
var controllers_1 = require("./controllers");
var services_1 = require("./services");
var routes_1 = __importDefault(require("./config/routes"));
/**
 * @ngdoc module
 * @module rinca.apps.contact
 * @name rinca.apps.contact
 * @packageName rinca.apps
 * @description A module that includes the contact component.
 */
angular.module('rinca.apps.contact', ['ui.router'])
    .controller('ContactController', controllers_1.ContactController)
    .service('_contact', services_1.ContactService)
    .config(routes_1.default);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/contact/index.ts
// module id = 444
// module chunks = 0